import type { IframeTunnelRequest } from '@/common/interop/iframe';
import type { TunnelResponse } from '@/common/interop/tunnel';

import { appId } from './path';

export async function tunnel({
  instanceId,
  instanceTitle,
  instanceUrl,
}: IframeTunnelRequest): Promise<TunnelResponse | undefined> {
  const tunnelUrl = `/api/tunnel/${appId}?title=${encodeURIComponent(
    instanceTitle || '',
  )}&src=${encodeURIComponent(
    instanceUrl || '',
  )}&instanceId=${encodeURIComponent(instanceId || '')}`;
  try {
    const res = await fetch(tunnelUrl);
    return res.json();
  } catch (err) {
    console.error('failed to call tunnel:', err);
  }
}
